import gql from 'graphql-tag';

const QUERY_CURRENT_CITY = gql`
  query CurrentCity($cityId: String, $locale: CityLocale!) {
    currentCity: city(cityId: $cityId, enabled: true) {
      id
      currencyIsoCode
      maximumPrice
      cityName(locale: $locale)
      country {
        countryIsoCode
        countryId
      }
      minimumStaying
    }
  }
`;

export const getCurrentCityQuery = client => (cityId, locale) =>
  client.query({
    query: QUERY_CURRENT_CITY,
    fetchPolicy: 'cache-first',
    variables: {
      locale,
      cityId
    }
  });

export default { getCurrentCityQuery };
